import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const ConfirmActionDialog = ({
  isVisible,
  onClose,
  onConfirm,
  message = 'この内容でよろしいですか？',
  confirmLabel = 'はい',
  cancelLabel = 'いいえ',
  loading = false,
}) => (
  <BaseDialog isVisible={isVisible} onClose={onClose} maxWidth="min(92vw, 420px)" clickOutsideToClose={!loading}>
    <Box sx={{ width: 360, maxWidth: '100%', p: 1 }}>
      <Typography variant="body1" sx={{ fontWeight: 700, mb: 2, whiteSpace: 'pre-line' }}>
        {message}
      </Typography>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={loading}>
          {confirmLabel}
        </Button>
      </Stack>
    </Box>
  </BaseDialog>
);

export default ConfirmActionDialog;
